import angular from 'angular';
export default angular.module('app.interface.tooltipHelper', [])
    .factory('$position', ['$document', '$window', function ($document, $window) {
        function getStyle(el, cssprop) {
            if (el.currentStyle) { //IE
                return el.currentStyle[cssprop];
            }
            else if ($window.getComputedStyle) {
                return $window.getComputedStyle(el)[cssprop];
            }
            // finally try and get inline style
            return el.style[cssprop];
        }
        /**
         * Checks if a given element is statically positioned
         * @param element - raw DOM element
         */
        function isStaticPositioned(element) {
            return (getStyle(element, "position") || 'static') === 'static';
        }
        /**
         * returns the closest, non-statically positioned parentOffset of a given element
         * @param element
         */
        let parentOffsetEl = function (element) {
            let docDomEl = $document[0];
            let offsetParent = element.offsetParent || docDomEl;
            while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent)) {
                offsetParent = offsetParent.offsetParent;
            }
            return offsetParent || docDomEl;
        };
        return {
            /**
             * Provides read-only equivalent of jQuery's position function:
             * http://api.jquery.com/position/
             */
            position: function (element) {
                let elBCR = this.offset(element);
                let offsetParentBCR = { top: 0, left: 0 };
                let offsetParentEl = parentOffsetEl(element[0]);
                if (offsetParentEl !== $document[0]) {
                    offsetParentBCR = this.offset(angular.element(offsetParentEl));
                    offsetParentBCR.top += offsetParentEl.clientTop;
                    offsetParentBCR.left += offsetParentEl.clientLeft;
                }
                return {
                    width: element.prop('offsetWidth'),
                    height: element.prop('offsetHeight'),
                    top: elBCR.top - offsetParentBCR.top,
                    left: elBCR.left - offsetParentBCR.left
                };
            },
            /**
             * Provides read-only equivalent of jQuery's offset function:
             * http://api.jquery.com/offset/
             */
            offset: function (element) {
                let boundingClientRect = element[0].getBoundingClientRect();
                return {
                    width: element.prop('offsetWidth'),
                    height: element.prop('offsetHeight'),
                    top: boundingClientRect.top + $window.pageYOffset,
                    left: boundingClientRect.left + $window.pageXOffset
                };
            }
        };
    }])
    .name;
